import React from "react";

const Button = ({ label, onClick, color = "primary", type = "button" }) => {
  const bgColor = color === "primary" ? "bg-indigo-500" : "bg-gray-300";
  const hoverColor = color === "primary" ? "hover:bg-indigo-600" : "hover:bg-gray-400";
  const textColor = color === "primary" ? "text-white" : "text-gray-800";

  return (
    <button
      type={type}
      onClick={onClick}
      className={`px-4 py-2 rounded-lg font-medium ${bgColor} ${hoverColor} ${textColor}`}
    >
      {label}
    </button>
  );
};

export default Button;
